import React from "react";
import { locationData } from "../../secondUtils/constants";
import { IoLocationOutline } from "react-icons/io5";

const LocationSection = (props) => {
    const { language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    return (
        <div className="main">
            <div className="LocationSection-container"
                data-aos="fade-up"
                data-aos-easing="ease-out-bounce"
                data-aos-delay="500"
                data-aos-duration="3000">
                {
                    locationData?.map((v, i) => {
                        return (
                            <div>
                                <img src={v?.img} alt="" />
                                <div className="location-btn-div">
                                    <button className="location-btn">
                                        <IoLocationOutline />
                                    </button>
                                </div>
                                <h2>
                                    {isELSelect ? v?.name : (isAlSelect ? v?.alName : v?.glName)}
                                </h2>
                                <p>
                                    {isELSelect ? v?.text1 : (isAlSelect ? v?.alText1 : v?.glText1)}
                                </p>
                                <p>
                                    {isELSelect ? v?.text2 : (isAlSelect ? v?.alText2 : v?.glText2)}
                                </p>
                                <p>{v?.text3}</p>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default LocationSection